<app-audio-asset [asset]="clip.controls.asset" />
